import React from 'react';

const MobileMenuButton = ({ isOpen, onClick, isLandingPage = false }) => {
  return (
    <button
      className={`mobile-menu-btn ${isLandingPage ? 'landing-page' : ''}`}
      onClick={onClick}
      aria-label="Toggle mobile menu"
      aria-expanded={isOpen}
    >
      <div className={`hamburger ${isOpen ? 'open' : ''}`}>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </button>
  );
};

export default MobileMenuButton;

